import { SortOrder } from '@/enums/SortOrder';
import qs from 'qs';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: InviteState = {
  all: [],
  viewing: undefined,
};

const getters: GetterTree<InviteState, RootState> = {
  all(state: InviteState): Invite[] {
    return state.all;
  },
  viewing(state: InviteState): Invite | undefined {
    return state.viewing;
  },
};

const mutations: MutationTree<InviteState> = {
  RESET(state: InviteState) {
    state.all = [];
    state.viewing = undefined;
  },
  UPDATE_MODEL(state: InviteState, payload: Invite) {
    const index = state.all.findIndex((model: Invite) => model.id === payload.id);

    if (index === -1) {
      state.all.push(payload);
    } else {
      state.all[index] = payload;
    }
  },
  ADD_MODEL(state: InviteState, payload: Invite) {
    state.all.push(payload);
  },
  ADD_MODELS(state: InviteState, payload: Invite[]) {
    state.all = [...state.all, ...payload];
  },
  SET_MODELS(state: InviteState, payload: Invite[]) {
    state.all = payload;
  },
  SET_VIEWING(state: InviteState, payload: Invite) {
    state.viewing = payload;
  },
};

const actions: ActionTree<InviteState, RootState> = {
  index({ commit, rootState }, payload: { query?: IndexQuery<PimAccount> } = { query: { s: { created_at: SortOrder.DESC, id: SortOrder.ASC }, per_page: 20 } }) {
    const queryString = qs.stringify(payload.query, { encode: false });

    return rootState.api
      .get(`api/invites?${queryString}`, { withCredentials: true })
      .then((response: { data: Invite }) => {
        if (payload.query?.hasOwnProperty('after')) {
          commit('ADD_MODELS', response.data);
        } else {
          commit('SET_MODELS', response.data);
        }

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  read({ commit, rootState }, payload: { id: number }) {
    return rootState.api
      .get(`api/invites/${payload.id}`, { withCredentials: true })
      .then((response: { data: Invite }) => {
        commit('UPDATE_MODEL', response.data);

        commit('SET_VIEWING', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  update({ commit, rootState }, payload: Invite) {
    return rootState.api
      .put(`api/invites/${payload.id}`, payload, { withCredentials: true })
      .then((response: { data: Invite }) => {
        commit('UPDATE_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  create({ commit, rootState }, payload: Invite) {
    return rootState.api
      .post(`api/invites`, payload, { withCredentials: true })
      .then((response: { data: Invite }) => {
        commit('ADD_MODEL', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
